import { Component, h, Prop, State, Host, Listen, Element } from '@stencil/core';

@Component({
  tag: 'ae-speedbump',
  styleUrl: 'ae-speedbump.scss',
  shadow: false,
})
export class AeSpeedbump {

  @Element() root: HTMLElement;

  @Prop() returnText: string;
  @Prop() continueText: string;
  @Prop() defaultMessage: string;
  @Prop() speedbumpSelector: string;

  @State() info = {
    open: false,
    message: '',
    url: ''
  };

  @Listen('click', { target: 'document' })
  openSpeedbump(e: any) {
    let targetElement = (e.target as HTMLElement);

      while (targetElement != null) {
        if (targetElement.matches('.speedbump-link')) {
          e.preventDefault();
          const url = targetElement.getAttribute('href');

          this.info = {
            open: true,
            message: this.defaultMessage,
            url: url
          };
          return;
        }
        targetElement = targetElement.parentElement;
      }
  }

  closeSpeedbump(e, allowDefault = false) {
    if (!allowDefault) {
      e.preventDefault();
    }

    this.info = {
      open: false,
      message: '',
      url: ''
    };
  }

  setFocus() {
    
    if (this.info.open) {
      const returnLink = this.root.querySelector('.btn-tertiary') as HTMLAnchorElement;
      returnLink?.focus();
    };
  }

  componentDidRender() {
    this.setFocus();
  }

  render() {
    if (!this.info.open) {
      return (<Host />);
    }

    return (
      <div class="speedbump" role="alert" aria-label={this.info.message}>
        <div class="speedbump__overlay" onClick={(e) => {this.closeSpeedbump(e)}}></div>
        <div class="speedbump__inner">
            <div class="speedbump__content">
              <slot />
            </div>

            <p class="speedbump__message" innerHTML={this.info.message}>
            </p>

            <div class="speedbump__actions">
            <a
                  href={this.info.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={this.continueText}
                  class="btn btn-secondary"
                  onClick={(e) => {this.closeSpeedbump(e, true)}}>
                  {this.continueText}
                </a>
                <a
                  href="#"
                  aria-label={this.returnText}
                  onClick={(e) => {this.closeSpeedbump(e)}}
                  class="btn btn-tertiary">
                  {this.returnText}
                </a>
            </div>
        </div>
      </div>
    );
  }

}
